import React, { useRef, useState } from 'react';
import { faAngleDown, faDownload} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {LineSkeleton} from '../../Skeletons/skeletonTemplates';
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction"
import { ButtonSkeleton } from '../../Skeletons/skeletonTemplates';
import { handleCaptureClick } from '../utils';

export default function CourseContentComponent (props) {
    const[isOpen, setIsOpen] = useState(false)
    const myRef = useRef(null)
    const executeScroll = () => {
        if(!isOpen){
            gtagHelperFunction("clickopen","showmore_courses",window.location.href)
        }
        setIsOpen(!isOpen)
        myRef.current.scrollIntoView()
    }
    

    function calcPoint(num) {
      if (num < 10)
        return "0" + num;
        return num;  
    }
    
    if (props.data && props.data.content && Object.keys(props.data.content).length === 0)
        return (<div />);

    var content = props.data ? props.data.content : undefined;
    var data = [];
    
    if (content) {
        Object.keys(content).map((temp, index) => {
            data.push({"key": index, "title" : temp, "description" : content[temp]});
        })
    }
    
    const initialItems = 4;
    
    var items =[]; 
    var extraItems = [];
    
    if (!props.data) {
        items = []
        for (var i = 0; i < 5; i++) {
            items.push(
                <li key = {i} className="list-group-item">
                    <div className = "row alignContentIndex">
                        <div className = "col-12">
                            {LineSkeleton(4)}
                        </div>
                    </div>
                </li>
            )
        }
    }
    else if (data.length) {
        items = data.slice(0, initialItems).map((item, index) =>
            <li key = {index} className="list-group-item">
                <div className = "row alignContentIndex">
                    <div className = "col-2 text-success d-block d-sm-none text-left sofia-pro"><h2>{calcPoint(item.key + 1)}</h2></div>
                    <div className = "col-1 text-success d-none d-sm-block text-left sofia-pro"><h2>{calcPoint(item.key + 1)}</h2></div>
                    <div className = "col-10 d-block d-sm-none">
                        <div className = "h5 text-left font-weight-bold sofia-pro contentHeading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                    </div>
                    <div className = "col-11 d-none d-sm-block">
                        <div className = "h5 text-left font-weight-bold sofia-pro contentHeading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                    </div>
                </div>
                <div className = "row">
                    <div className = "col-2 d-block d-sm-none"></div>
                    <div className = "col-1 d-none d-sm-block text-left"></div>
                    <div className = "col-12 d-block d-sm-none">
                        <div className = "text-left text-muted urw-din content-description" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                    </div>
                    <div className = "col-11 d-none d-sm-block">
                        <div className = "text-left text-muted urw-din content-description" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                    </div>
                </div>
            </li>
        )
        extraItems = data.slice(initialItems).map((item, index) =>
            <li key = {index} className="list-group-item">
                <div className = "row alignContentIndex">
                    <div className = "col-2 text-success d-block d-sm-none text-left"><h2>{calcPoint(item.key + 1)}</h2></div>
                    <div className = "col-1 text-success d-none d-sm-block text-left"><h2>{calcPoint(item.key + 1)}</h2></div>
                    <div className = "col-10 d-block d-sm-none">
                        <div className = "h5 text-left font-weight-bold sofia-pro" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                    </div>
                    <div className = "col-11 d-none d-sm-block">
                        <div className = "h5 text-left font-weight-bold sofia-pro heading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                    </div>
                </div>
                <div className = "row">
                    <div className = "col-2 d-block d-sm-none"></div>
                    <div className = "col-1 d-none d-sm-block text-left"></div>
                    <div className = "col-12 d-block d-sm-none">
                        <div className = "text-left text-muted urw-din" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                    </div>
                    <div className = "col-11 d-none d-sm-block">
                        <div className = "text-left text-muted urw-din" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                    </div>
                </div>
            </li>
        )
    }

    return (
        <section className = "courseContent">
            <div className="container">
                <div className="col-md-12 mb-5">
                    <h2 className = "font-weight-bold sofia-pro">Course Content</h2>
                </div>
                <div ref = {myRef} className = "mx-auto col-md-10">
                    <ul className="list-group">
                        {items}
                    </ul>
                </div>
                
                {/*Load Remaining course contents on Button Click  */}
                <div className="collapse" id="contentsExpanded">
                    <div className = " mx-auto col-md-10">
                        <ul className="list-group">
                            {extraItems}
                        </ul>
                    </div>
                </div>
                
                {/* Show more button loads more content */}
                {extraItems.length > 0 &&
                    <div className = "mx-auto col-md-10">
                        <button onClick = {executeScroll} className="btn btn-light col-md-12 text-success" type="button" data-toggle="collapse" data-target="#contentsExpanded" aria-expanded="false" aria-controls="contentsExpanded">
                            {!isOpen &&
                                "Show More " 
                            } 
                            {isOpen &&
                                "Hide " 
                            } 
                            <FontAwesomeIcon icon = {faAngleDown}></FontAwesomeIcon>
                        </button>
                    </div>
                } 
            </div>
            {props.isLoggedIn === undefined &&
                <div className='mx-auto col-2 mt-4'>
                    <ButtonSkeleton type = "btn-skeleton-sm"/>
                </div>
            }
            {props.isLoggedIn === false && 
                <div className = "mx-auto col-md-10 mt-4">
                    <a href={`${window.location.href}?loginMode=${1}`} className="btn btn-success col-12 col-sm-3 sofia-pro login-modal-btn">Login to view detailed syllabus</a>
                </div>
            }
            {(props.data && props.data.syllabusPDFLink && props.data.syllabusPDFLink.length > 0 && props.isLoggedIn) && 
                <div className = "mx-auto col-md-10 mt-4">
                    <a target = "_blank" href = {props.data.syllabusPDFLink} className = "btn btn-success col-12 col-sm-3 sofia-pro" onClick={() => handleCaptureClick(props.courseSlug,'clicked_syllabus_download')} ><FontAwesomeIcon icon = {faDownload} 
                    onClick={()=>gtagHelperFunction("download","syllabus_courses",window.location.href)}></FontAwesomeIcon>View Detailed Syllabus</a>
                </div>
            }
        </section>
    );
}
